import { MyCommunity as MyCommunityFeature } from '../../features/MyCommunity/MyCommunity'

export const MyCommunity = () => <MyCommunityFeature />
